<template>
	<v-textarea
		:class="`input-textarea${singleLine ? ' single-line' : ''}`"
		:label="label"
		:placeholder="placeholder"
		:counter="counter"
		:required="required"
		:disabled="disabled"
		:readonly="readonly"
		:clearable="clearable"
		:value="text"
		:error-count="3"
		:rows="singleLine ? 1 : rows"
		:error-messages="errors"
		:outlined="outlined"
		no-resize
		@keydown="onKeydown($event)"
		@input="onInput($event)"
		@change="onChange($event)"
	/>
</template>

<script>
export default {
	props: {
		disabled: Boolean,
		readonly: Boolean,
		label: String,
		placeholder: String,
		value: [String, Number],
		required: Boolean,
		clearable: Boolean,
		counter: [Boolean, Number, String],
		outlined: Boolean,
		rows: {
			type: [Number, String],
			default: 5,
		},
		singleLine: {
			type: Boolean,
			default: false,
		},
		errors: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		text() {
			if (this.singleLine) {
				return (this.value || '').replace(/\n/g, '')
			}
			return (this.value || '')
		},
	},
	methods: {
		onKeydown(event) {
			if (this.singleLine && event.which === 13) {
				event.preventDefault()
			}
		},
		onInput(event) {
			this.$emit('input', event)
		},
		onChange(event) {
			this.$emit('change', event)
		},
	},
}
</script>

<style scoped>
	.input-textarea.single-line >>> textarea {
		white-space: nowrap;
		overflow-x: scroll;
		overflow-y: hidden;
	}
</style>
